import { dropdownMapping, fetchAllPostPromisedData, fetchAllPromisedData, fetchDeletePromisedData } from "../../../common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "../../../common/constant";

export const getDropdowns = async () => {
  try {
    const resp = await Promise.all([
      dropdownMapping(
        endpoint.businessArea.getAllActive,
        "businessAreaDispValue",
        "id",
        "regionId"
      ),
      dropdownMapping(
        endpoint.region.getAllActive,
        "regionDispValue",
        "id"
      ),
      dropdownMapping(
        endpoint.academic_career.getAllActive,
        "academicCareerDispValue",
        "id"
      ),
      dropdownMapping(
        endpoint.getRole.roleWithApprovalPermissions,
        "roleName",
        "id",
      ),

    ]);
    return {
      allActiveBu: resp[0],
      allActiveRegions: resp[1],
      allActiveCareers: resp[2],
      allActiveRoles: resp[3],
    };
  } catch (err) {
    console.error(err);
  }
}



export const getConfigs = async () => {
  return await fetchAllPromisedData(endpoint.epmrConfig.get);
}

export const createEmprConfig = async (form) => {
  let reqObj = createEpmrConfigReqObj(form);
  return await fetchAllPostPromisedData(endpoint.epmrConfig.create, reqObj);
}

export const updateEpmrConfig = async (form) => {
  let reqObj = createEpmrConfigReqObj(form);
  return await fetchAllPostPromisedData(`${endpoint.epmrConfig.update}/${form?.id}`, reqObj, 'put');
}

export const deleteEpmrCofig = async (id) => {
  return await fetchDeletePromisedData(`${endpoint.epmrConfig.delete}/${id}`, true);
}

export const getFormattedEmprConfig = (config, dropdownData) => {

  const { businessAreaMappings, academicCareerMappings, l1RoleMappings, l2RoleMappings, id, updatedOn } = config;
  const { allActiveBu, allActiveCareers, allActiveRoles, allActiveRegions } = dropdownData;

  const updatedConfig = {
    id,
    updatedOn,
    businessArea: businessAreaMappings?.map(bu => allActiveBu?.find(el => el?.value === bu?.businessAreaId)),
    academicCareer: academicCareerMappings?.map(career => allActiveCareers?.find(el => el?.value === career?.academicCareerId)),
    l1Roles: l1RoleMappings?.map(role => allActiveRoles?.find(el => el?.value == role?.roleId)),
    l2Roles: l2RoleMappings?.map(role => allActiveRoles?.find(el => el?.value == role?.roleId)),
  }

  updatedConfig.regions = allActiveRegions?.filter(region => updatedConfig.businessArea?.find(bu => bu?.regionId?.includes(region?.value)));

  return updatedConfig;
}

const formatToReqObjItem = (item, labelField, valueField) => {
  return { [labelField]: item?.label, [valueField]: item?.value }
}

const createEpmrConfigReqObj = form => {
  const { businessArea, academicCareer, l1Roles, l2Roles } = form;
  return {
    status: "ACTIVE",
    businessAreaMappings: businessArea?.map(bu => formatToReqObjItem(bu, "businessArea", "businessAreaId")),
    academicCareerMappings: academicCareer?.map(career => formatToReqObjItem(career, "academicCareer", "academicCareerId")),
    l1RoleMappings: l1Roles?.map(role => formatToReqObjItem(role, "roleName", "roleId")),
    l2RoleMappings: l2Roles?.map(role => formatToReqObjItem(role, "roleName", "roleId")),

  }

}
